import React from 'react';
import InfoGreen from '../../../assets/images/info-green.svg';
import InfoRed from '../../../assets/images/info-red.svg';

const ContractConfirmation = ({
  onDismiss,
  onConfirm,
  isAccept,
  contractDetails,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-transparent z-[999]">
      <div
        style={{ borderRadius: '16px' }}
        className="bg-white w-1/4 shadow-2xl"
      >
        <div className="mt-4 flex justify-center">
          <img
            src={isAccept === 2 ? InfoGreen : InfoRed}
            alt="logo"
            className="self-start"
          />
        </div>
        <div className="px-8 pt-4 pb-2 space-x-3 flex justify-center">
          <div className="text-center">
            {isAccept === 3 ? (
              <h3 className="text-lg font-medium text-gray-900">{`Reason of rejection`}</h3>
            ) : (
              <h3 className="text-lg font-medium text-gray-900">{`Are you sure you want to ${isAccept === 2 ? 'accept' : 'reject'} this contract?`}</h3>
            )}
            <p className="text-sm text-gray-600">
              {isAccept === 2
                ? 'By accepting, you agree to all terms and conditions outlined in the agreement. This action cannot be undone.'
                : isAccept === 3
                  ? contractDetails.reason
                  : 'Rejecting this contract will notify the relevant parties and may require you to provide a reason.'}
            </p>
          </div>
        </div>
        <div className="flex justify-end space-x-2 p-3 border-t border-[#E2E4E9]">
          <button
            onClick={onDismiss}
            className="px-3 py-2 text-gray-700 rounded-lg hover:bg-gray-200 border border-[#E2E4E9]"
          >
            Dismiss
          </button>
          {isAccept !== 3 && (
            <button
              onClick={onConfirm}
              className={`px-3 py-2 bg-[${isAccept ? '#176448' : '#DF1C41'}] text-white rounded-lg hover:bg-green-700`}
            >
              {isAccept === 2 ? 'Yes, Accept' : 'Yes, Reject'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContractConfirmation;
